<div class="relative-left bottom-sheet-content full-width x-content-center y-items-center txt-center lato padding-20">
  <div>
    <h5 class="weight-300">
      Terms of Services
      <small class="block margin-top-5 weight-400">
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusantium deserunt a cum
      </small>
    </h5>
    <hr />
    <p class="weight-300 margin-top-10">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi fugit quas tempora quisquam, voluptates atque veniam fugiat suscipit aspernatur
      ipsum voluptate? Velit voluptas tenetur quis vitae assumenda repellendus neque pariatur?
    </p>
    <p class="weight-300 margin-top-bottom-5">
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Animi, dolor odit. Expedita aliquid nobis architecto. Exercitationem animi adipisci
      tenetur asperiores iure, temporibus nam accusantium, architecto facilis, repellat laboriosam veritatis illo!
    </p>
    <p class="weight-300 margin-top-bottom-5">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque voluptatibus, commodi nam laudantium laboriosam excepturi ullam, unde dolorem
      incidunt nihil numquam facilis labore. Aspernatur sunt distinctio commodi deleniti animi nemo..
    </p>
    <button (click)="closeTerminsAndConditions()" mat-button class="button black md fine margin-top-15" aria-label="Close Dialog">Accept</button>
  </div>
</div>
